module.exports = __webpack_public_path__ + "static/pic01-ca24a2a2adc212c543dc96c334759372.png";